/* eslint-disable */
function throttle(after, wait) {
    var timer
    var isScroll
    return function () {
        if (isScroll) return
        isScroll = true
        timer && clearTimeout(timer)
        timer = setTimeout(function () {
            after && after()
            isScroll = false
            timer = null
        }, wait)
    }
}

function backTop(_this) {
    _this.$nextTick(() => {
        const header = document.getElementsByClassName('header').length ? document.getElementsByClassName('header')[0].clientHeight : 0
        window.scrollTo(
            0,
            header +
            document.getElementsByClassName('el-carousel')[0].clientHeight -
            document.getElementsByClassName('header-box')[0].clientHeight *
            2
        )
    })
}
export { throttle, backTop }


// WEBPACK FOOTER //
// ./src/utils/util.js